module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO MARQUESBRANDING_DESTAQUES-28a4f721c9e8f1d612abb5f14342924f.png";